import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var productCareDoNotDryCleanIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.966 1c3.19 0 6.067 1.335 8.12 3.465l2.04-1.721a.958.958 0 0 1 1.347.113l.313.368-2.772 2.34a11.16 11.16 0 0 1 .433 12.773l1.733 1.367a.958.958 0 0 1 .157 1.346l-.297.375-2.445-1.929a11.266 11.266 0 0 1-8.629 4.024 11.25 11.25 0 0 1-8.12-3.465l-2.768 2.336-.308-.364a.96.96 0 0 1 .113-1.354l2.036-1.718A11.17 11.17 0 0 1 .686 12.26c0-2.515.841-4.832 2.242-6.708L0 3.24l.298-.375a.959.959 0 0 1 1.347-.158l2.21 1.747A11.251 11.251 0 0 1 11.967 1Zm.316 11.935-7.338 6.194a9.822 9.822 0 0 0 14.522-.524l-7.184-5.67ZM4.056 6.442a9.75 9.75 0 0 0-1.93 5.818 9.75 9.75 0 0 0 1.892 5.77l7.112-6.005Zm15.858.05-6.51 5.497 6.907 5.452a9.746 9.746 0 0 0 1.495-5.18 9.742 9.742 0 0 0-1.892-5.768Zm-7.948-4.055a9.817 9.817 0 0 0-6.98 2.908l7.265 5.734 6.737-5.687a9.816 9.816 0 0 0-7.022-2.955Z",
  fill: "currentColor",
  fillRule: "evenodd"
}));

export { productCareDoNotDryCleanIcon as default };
//# sourceMappingURL=productCareDoNotDryCleanIcon.js.map
